import { Box, Typography } from '@mui/material';
import { useSettings } from 'contexts/Settings/Settings';
import * as setup from 'setup';
import FunnelInput from '../FunnelInput/FunnelInput';
import FunnelZoomButton from '../FunnelZoomButton/FunnelZoomButton';
import { FunnelConversionContainer } from './FunnelConversion.styles';

export default function FunnelConversion({
    disableInputs,
    disableZooms,
    hideBody,
    rangeMode,
    step,
    zoomable,
    zoomed,
    onChange,
    onZoom,
}: FunnelConversionProps) {

    const settings = useSettings();

    const conversionSetup = setup.game.steps[step.index].conversion;

    return (
        <FunnelConversionContainer $compact={hideBody}>
            {!hideBody && <>
                {(zoomable || zoomed) && (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            top: 'calc(50% - 15px)'
                        }}>
                        <FunnelZoomButton
                            disabled={disableZooms}
                            type={zoomable ? 'in' : 'out'}
                            onClick={type => onZoom?.(step, type)}
                        />
                    </Box>
                )}
                <Typography
                    align="center"
                    color={setup.colors.black}
                    variant="montserrat412"
                    sx={{
                        margin: 0,
                        marginTop: 1,
                        marginBottom: 0
                    }}>
                    Conversion To Next Step
                </Typography>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: 0.25,
                        justifyContent: 'center'
                    }}>
                    {(rangeMode || settings.debugFunnel) && <>
                        <Typography variant="montserrat410">
                            MIN
                        </Typography>
                        <FunnelInput
                            decimals={conversionSetup.decimals}
                            disabled={disableInputs}
                            max={step.conversion.max}
                            multiplier={conversionSetup.multiplier}
                            size={16}
                            value={step.conversion.min}
                            onChange={value => onChange({ min: value })}
                        />
                        <Typography variant="montserrat410">
                            MAX
                        </Typography>
                    </>}
                    <FunnelInput
                        decimals={conversionSetup.decimals}
                        disabled={disableInputs}
                        min={step.conversion.min}
                        multiplier={conversionSetup.multiplier}
                        size={16}
                        value={step.conversion.max}
                        onChange={value => onChange({ max: value })}
                    />
                    <Typography variant="montserrat412">
                        {conversionSetup.operator}
                    </Typography>
                </Box>
            </>}
        </FunnelConversionContainer>
    );

}